<template>
  <div class="block-chain-overview">
    <key-indicator></key-indicator>
    <detail-table :title="title" :table-col="infoCol" :list="info">
      <template #actions>
        <btn-style :btn-list="operate"></btn-style>
      </template>
    </detail-table>
    <auth-manage ref="authManage"></auth-manage>
    <edit-setting ref="editSetting"></edit-setting>
  </div>
</template>

<script>
import auth from '@/auth/index'
import keyIndicator from './keyIndicator'
import authManage from './authManage'
import editSetting from './editSetting'

import chainId from '@/assets/images/tableIcon/chain-id.png'
import chainInterval from '@/assets/images/tableIcon/chain-interval.png'
import chainVersion from '@/assets/images/tableIcon/now-version.png'
import chainCapacity from '@/assets/images/tableIcon/chain-capacity.png'
import chainName from '@/assets/images/tableIcon/chain-name.png'
import chainTime from '@/assets/images/tableIcon/time.png'

export default {
  name: 'Overview',
  components: {
    keyIndicator,
    authManage,
    editSetting
  },
  data() {
    return {
      title: '区块链信息',
      operate: [
        {
          btnContent: '链权限管理',
          icon: 'icon-authority',
          click: () => {
            return this.reviseAuth()
          },
          auth: auth.blockchain.checkDetail.overview.authManage
        },
        {
          btnContent: '修改链配置',
          icon: 'icon-edit',
          click: () => {
            return this.reviseSetting()
          },
          auth: auth.blockchain.checkDetail.overview.modConfig
        }
      ],
      infoCol: [
        { label: '区块链ID', value: 'ChainId', icon: chainId },
        { label: '交易过期时长', value: 'TxTimeout', icon: chainTime },
        { label: '区块链名称', value: 'ChainName', icon: chainName },
        { label: '区块链版本', value: 'Version', icon: chainVersion },
        { label: '出块间隔', value: 'BlockInterval', icon: chainInterval },
        { label: '配置版本', value: 'Sequence', icon: chainVersion },
        { label: '区块链最大容量', value: 'BlockTxCapacity', icon: chainCapacity },
        {
          label: '区块链来源',
          value: 'IsExternal',
          formatter: this.transChainOrigin,
          icon: chainId
        }
      ],
      info: {}
    }
  },
  mounted() {
    this.info = JSON.parse(this.$route.query.detail)
    console.log(this.info)
  },
  methods: {
    reviseAuth() {
      this.$refs.authManage.handleOpen()
    },
    reviseSetting() {
      this.$refs.editSetting.handleOpen()
    },
    refresh() {},
    transChainOrigin(info) {
      return info.IsExternal ? '平台外创建' : '平台内创建'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('block-chain-overview', (), ());

.block-chain-overview {
  @include adaptation(
    (
      --block-chain-overview-detail-section-padding: 4px 0
    )
  );

  .cbaas-detail-table {
    /deep/ .cbaas-detail-section {
      padding: var(--block-chain-overview-detail-section-padding);
    }
  }
}
</style>
